import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

export const useStyles = makeStyles(theme => ({
  heading: {
    margin: '12px 20px',
    color: theme.palette.primary.main,
    fontWeight: 500,
    lineHeight: 'normal',
  },
}))

export const Root = styled.div`
  width: 100%;
  padding: 15px 10px 33px 50px;
  display: grid;
  row-gap: 38px;
`

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`
